// SlideContent.js
import React from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

const SlideContent = ({ slide, onClick, i18n }) => {
  const isArabic = i18n.language === 'ar';
  
  return (
    <div 
      className="flex flex-col items-start justify-center text-start space-y-6 z-10 animate-fadeIn"
      dir={isArabic ? "rtl" : "ltr"}
    >
      <h1 
        className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold leading-tight mb-4 text-primeColor-500 drop-shadow-lg"
      >
        {slide.header}
      </h1>
      <p 
        className={`text-base sm:text-lg md:text-xl lg:text-2xl font-light leading-relaxed text-gray-700 ${
          isArabic ? "text-right" : "text-left"
        } tracking-wide max-w-2xl`}
      >
        {slide.content}
      </p>
      <button
        onClick={onClick}
        className="group px-8 py-4 bg-primeColor-500
         text-white rounded-lg shadow-lg hover:bg-primeColor-600 transition-all duration-300 text-lg font-semibold transform hover:scale-105 hover:shadow-xl flex items-center gap-2"
      >
        <span>{slide.labelBtn}</span>
        {isArabic ? (
          <FaArrowLeft className="transition-transform duration-300 group-hover:-translate-x-1" />
        ) : (
          <FaArrowRight className="transition-transform duration-300 group-hover:translate-x-1" />
        )}
      </button>
    </div>
  );
};

export default SlideContent;
